import React, { useState } from 'react';
import StudentDayAttendance from './dayWiseAttendance/StudentDayAttendance';
import StudentMonthAttendance from './monthWiseAttendance/StudentMonthAttendance';
import './StudentDayMonthAttendanceContent.css';

const StudentDayMonthAttendanceContent = (props) => {
  const { loginFromParent, loader, LoaderPopUp, ParentHeader } = props;
  const [activeTab, setActiveTab] = useState("day-wise");

  return (
    <>
      {loginFromParent }
      <div className="attendance-wrapper">
        <div className="attendance-container">
          <div className="attendance-tab-header">
            <button
              className={`attendance-tab ${activeTab === "day-wise" ? "active-tab" : ""}`}
              onClick={() => setActiveTab("day-wise")}
            >
              Day-wise Attendance
            </button>
            <button
              className={`attendance-tab ${activeTab === "monthly" ? "active-tab" : ""}`}
              onClick={() => setActiveTab("monthly")}
            >
              Monthly Attendance
            </button>
          </div>

          <div className="attendance-tab-content">
            {activeTab === "day-wise" ? (
              <StudentDayAttendance />
            ) : (
              <StudentMonthAttendance />
            )}
          </div>
        </div>
      </div>

      {loader && <LoaderPopUp />}
    </>
  );
};

export default StudentDayMonthAttendanceContent;
